import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild, Output, EventEmitter, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import * as events from 'devextreme/events';
import { Subscription } from 'rxjs';
import { ControlPanelService } from 'src/states/control-panel.service';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent)
  menu: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  @Input()
  items: any[];

  @Input()
  set selectedItem(value: string) {
    let isFound = false;
    if (this.menu?.instance) {
      const nodes = this.menu?.instance.getNodes();
      nodes.forEach(node => {
        const children = node.children;
        children.forEach(child => {
          if (child.itemData.Route === value) {
            this.menu?.instance.selectItem(child.key);
            //this.menu.instance.collapseAll();
            this.menu?.instance.beginUpdate();
            isFound = true;
          }
        });
      });
      if (!isFound) {
        // console.log('collapsing menus (1)');
        // this.menu.instance.collapseAll();
        // this.menu.instance.unselectAll();
      }
    }
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;
    if (val && this.menu?.instance) {
      // console.log('collapsing menus (2)');
      // this.menu.instance.collapseAll();
    }
  }

  constructor(
    private elementRef: ElementRef,
    private translate: TranslateService,
    private controlPanelService: ControlPanelService
    ) {
    // this.actions$.pipe(
    //   ofActionSuccessful(RouterDataResolved),
    //   map((action: RouterDataResolved) => action.routerState.root.firstChild.data));

    this.controlPanelService.changeMenuIsOpen.subscribe(res => {
      if(!res) {
        this.menu?.instance.collapseAll();
      }
    });
  }

  updateSelection(event) {
    const nodeClass = 'dx-treeview-node';
    const selectedClass = 'dx-state-selected';
    const leafNodeClass = 'dx-treeview-node-is-leaf';
    const element: HTMLElement = event.element;

    const rootNodes = element.querySelectorAll(`.${nodeClass}:not(.${leafNodeClass})`);
    Array.from(rootNodes).forEach(node => {
      node.classList.remove(selectedClass);
    });

    let selectedNode = element.querySelector(`.${nodeClass}.${selectedClass}`);
    while (selectedNode && selectedNode.parentElement) {
      if (selectedNode.classList.contains(nodeClass)) {
          selectedNode.classList.add(selectedClass);
      }

      selectedNode = selectedNode.parentElement;
    }
  }

  onItemClick(event) {
    this.selectedItemChanged.emit(event);
  }

  onMenuInitialized(event) {
    event.component.option('deferRendering', false);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.next(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }

  fetchLabel(item) {
    return this.translate.instant('Navigation.' + item.Label);
  }
}
